@if (loading()) {
	<section tuiContent>
		<div class="padding-v-8">
			<tui-loader size="xl" />
		</div>
	</section>
} @else if (form) {
	<section tuiContent>
		<form
			class="chemical-usage-log-form-dialog__form"
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
		>
			<label tuiLabel>
				{{ 'data.chemical' | transloco }}*

				<tui-textfield
					#chemicalTextfield
					[content]="
						chemicalTextfield.focused() ? '' : chemicalContent
					"
					tuiDropdownSheet
					tuiTextfieldSize="m"
				>
					<tui-data-list-wrapper
						*tuiDropdown
						[itemContent]="chemicalContent"
						[items]="chemicalOptions() | tuiFilterByInput"
					/>

					<ng-template #chemicalContent let-option>
						<ctx-chemical-row
							size="s"
							[chemical]="option.data"
							[asTableRow]="false"
							[showRevision]="false"
						/>
					</ng-template>

					<input tuiComboBox formControlName="chemical" />
				</tui-textfield>

				<tui-error formControlName="chemical" [order]="['required']" />
			</label>

			<label tuiLabel>
				{{ 'chemical.regulation-number' | transloco }}*

				<tui-textfield
					#revisionTextfield
					[content]="
						revisionTextfield.focused() ? '' : revisionContent
					"
					tuiDropdownSheet
					tuiTextfieldSize="m"
				>
					<tui-data-list-wrapper
						*tuiDropdown
						[itemContent]="revisionContent"
						[items]="revisionOptions() | tuiFilterByInput"
					/>

					<ng-template #revisionContent let-option>
						<div class="flex flex-col">
							<p class="m-0 font-bold">
								{{ option.data.regulationNumber }}
							</p>
							<small class="mt-[-2px] font-size-xsmall">
								{{
									'data.expires-on'
										| transloco
											: {
													date:
														option.data.expiresAt.toDate()
														| date: 'longDate',
											  }
								}}
							</small>
						</div>
					</ng-template>

					<input tuiComboBox formControlName="chemicalRevision" />
				</tui-textfield>

				@if (noActiveRevisions()) {
					<div tuiNotification size="s" appearance="warning">
						{{
							'chemical.usage-log.no-active-registration-numbers'
								| transloco
						}}
					</div>
				}

				<tui-error
					formControlName="chemicalRevision"
					[order]="['required']"
				/>
			</label>

			<label tuiLabel>
				{{ 'chemical.application-type.label' | transloco }}*

				<tui-textfield
					#applicationTypeTextfield
					[content]="
						applicationTypeTextfield.focused()
							? ''
							: applicationTypeContent
					"
					tuiDropdownSheet
					tuiTextfieldSize="m"
				>
					<tui-data-list-wrapper
						*tuiDropdown
						[itemContent]="applicationTypeContent"
						[items]="applicationTypeOptions() | tuiFilterByInput"
					/>

					<ng-template #applicationTypeContent let-option>
						{{ option.data.name }}
					</ng-template>

					<input tuiComboBox formControlName="applicationType" />
				</tui-textfield>

				<tui-error
					formControlName="applicationType"
					[order]="['required']"
				/>
			</label>

			<label tuiLabel>
				{{ 'chemical.usage-log.rei-hours' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="reiHours"
						tuiInput
						type="number"
						min="0"
						step="0.5"
						autocomplete="off"
					/>
				</tui-textfield>

				<tui-error formControlName="reiHours" [order]="['required']" />
			</label>

			<div class="form-divider"></div>

			<label tuiLabel>
				{{ 'chemical.usage-log.location' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="location"
						tuiInput
						type="text"
						autocomplete="off"
					/>
				</tui-textfield>

				<tui-error formControlName="location" [order]="['required']" />
			</label>

			<label tuiLabel>
				<span class="flex items-center">
					{{ 'chemical.usage-log.note' | transloco }}
					<tui-icon
						class="color-secondary scale-60 cursor-help"
						icon="@tui.info"
						[tuiHint]="
							'chemical.usage-log.note-internal-only' | transloco
						"
						tuiHintAppearance="dark"
					/>
				</span>

				<tui-textfield tuiTextfieldSize="m">
					<textarea
						tuiTextarea
						formControlName="note"
						[limit]="maxLength"
					></textarea>
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'chemical.usage-log.applied-at' | transloco }}*

				<tui-textfield tuiDropdownSheet tuiTextfieldSize="m">
					<input
						tuiInputDateTime
						timeMode="HH:MM AA"
						formControlName="appliedAt"
						[max]="maxDate()"
					/>
					<tui-calendar *tuiDropdown [max]="maxDate()" />
				</tui-textfield>

				<tui-error
					formControlName="appliedAt"
					[order]="['required', 'futureDate']"
				/>
			</label>

			<label tuiLabel>
				{{ 'chemical.usage-log.crops' | transloco }}

				<tui-textfield class="hidden" tuiTextfieldSize="m" />
				<ctx-dynamic-entity-list
					[items]="cropListItems()"
					[addButtonLabel]="'action.add'"
					[emptyMessage]="
						'chemical.usage-log.crops-empty' | transloco
					"
					(add)="onSelectCrops()"
					(remove)="onRemoveCrop($event)"
				/>
			</label>
		</form>
	</section>
}

<footer tuiFooter>
	<button
		tuiButton
		size="m"
		appearance="outline"
		type="button"
		(click)="onDismiss()"
	>
		{{ 'action.cancel' | transloco }}
	</button>

	<button
		tuiButton
		size="m"
		appearance="accent"
		type="button"
		(click)="onSubmit()"
		[loading]="busy()"
	>
		{{ 'action.create' | transloco }}
	</button>
</footer>
